<template>
  <PmInfoIconPure
    type="note"
    :size="props.size"
    :class="componentClass.root"
    @click="emit('open')"
  >
    <template #tooltip>
      <div :class="componentClass.element('content')">
        <div :class="componentClass.element('note')">
          <strong>{{ name }}:</strong><br />
          {{ note }}
        </div>

        <div
          v-if="noteAdditional"
          :class="[
            componentClass.element('note'),
            componentClass.className({
              element: 'note',
              modifier: 'additional',
            }),
          ]"
        >
          <strong>{{ nameAdditional }}:</strong><br />
          {{ noteAdditional }}
        </div>

        <div :class="componentClass.element('help')">
          Klicken um die {{ name }} vollständig anzuzeigen
          <template v-if="props.canBeEdited">oder zu bearbeiten</template>
        </div>
      </div>
    </template>
  </PmInfoIconPure>
</template>

<script setup lang="ts">
import { useComponentClass } from '@thomasaull-shared/composables'
import PmInfoIconPure, {
  type Props as PropsInfoIconPure,
} from '../basics/PmInfoIconPure/PmInfoIconPure.vue'
import type { Nilable } from '../../types/misc'

export interface Props {
  name?: string
  nameAdditional?: string
  note?: Nilable<string>
  noteAdditional?: string
  canBeEdited?: boolean // Temp prop until https://gitlab.com/pro-musik/frontend/-/issues/810 is done
  size?: PropsInfoIconPure['size']
}

export type Emits = {
  open: []
}

const props = withDefaults(defineProps<Props>(), {
  name: 'Bemerkung',
  nameAdditional: 'weitere Bemerkung',
  canBeEdited: true,
  size: 'default',
})

const emit = defineEmits<Emits>()

const componentClass = useComponentClass()
</script>

<style lang="scss">
.PmNoteIconPure {
  $block: &;

  &-note {
    @include mixin.truncateText($lines: 10);

    white-space: pre-line;
    max-width: 75ch;

    &--additional {
      margin-top: 8px;
    }
  }

  &-help {
    font-size: constant.$fontSize-default;
    font-weight: 500;
    color: color.$gray-500;
    grid-area: note;
    margin-top: 8px;
  }
}
</style>
